module.exports = __webpack_public_path__ + "img/warning.06b8bc69.svg";